(function () {
  'use strict';

  function initTVSVideoCarousel() {
    var carousel = document.getElementById('tvs-video-carousel');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('.tvs-vc__slide');
    var dots   = carousel.querySelectorAll('.tvs-vc__dot');
    var progressBar = document.getElementById('tvs-vc-progress');

    if (!slides.length) return;

    var current   = 0;
    var startTime = null;
    var rafId     = null;
    var paused    = false;

    // Read duration from schema setting stored in data attribute (seconds → ms)
    // Falls back to 7000ms
    var durationSec = parseInt(carousel.dataset.duration || '7', 10);
    var DURATION = durationSec * 1000;

    function goTo(index) {
      // Pause current video
      var currentVideo = slides[current].querySelector('.tvs-vc__video');
      if (currentVideo) currentVideo.pause();

      slides[current].classList.remove('active');
      dots[current].classList.remove('active');
      dots[current].setAttribute('aria-selected', 'false');

      current = index;

      slides[current].classList.add('active');
      dots[current].classList.add('active');
      dots[current].setAttribute('aria-selected', 'true');

      // Play new slide video
      var nextVideo = slides[current].querySelector('.tvs-vc__video');
      if (nextVideo) {
        nextVideo.currentTime = 0;
        nextVideo.play().catch(function () {
          // Autoplay blocked — silently continue, video stays paused
        });
      }

      startTime = performance.now();
    }

    function next() {
      goTo((current + 1) % slides.length);
    }

    function tick(timestamp) {
      if (paused) {
        startTime = timestamp;
        rafId = requestAnimationFrame(tick);
        return;
      }

      if (!startTime) startTime = timestamp;

      var elapsed = timestamp - startTime;
      var pct = Math.min((elapsed / DURATION) * 100, 100);

      if (progressBar) progressBar.style.width = pct + '%';

      if (elapsed >= DURATION) next();

      rafId = requestAnimationFrame(tick);
    }

    // Dot click navigation
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.slide, 10));
      });
    });

    // Pause on hover
    carousel.addEventListener('mouseenter', function () { paused = true; });
    carousel.addEventListener('mouseleave', function () { paused = false; });

    // Respect prefers-reduced-motion
    var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (motionQuery.matches) {
      var navEl = carousel.querySelector('.tvs-vc__nav');
      var progEl = carousel.querySelector('.tvs-vc__progress');
      if (navEl) navEl.style.display = 'none';
      if (progEl) progEl.style.display = 'none';
      slides.forEach(function (slide) { slide.classList.add('active'); });
      return;
    }

    // Play first slide video
    var firstVideo = slides[0].querySelector('.tvs-vc__video');
    if (firstVideo) {
      firstVideo.play().catch(function () {});
    }

    // Start loop
    startTime = performance.now();
    rafId = requestAnimationFrame(tick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTVSVideoCarousel);
  } else {
    initTVSVideoCarousel();
  }

})();